


































import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryAllShopNameList,QueryOrderInfoList,QueryAfterSaleRefundList,QueryOrderInfoCounts, ConfirmOrder, DeliveryOrder, RefusedOrder,BatchConfirmOrder,BatchDeliveryOrder, ConfirmRefund, ConfirmReturnRefundAfterLogistics, CancelRefund,ExportOrder } from '@/api'
import { DateFormat ,DateFormat2} from '@/utils/date/DateUtil'
import { PriceFormat, OrderStatusFormat, OrderTypeFormat, RefundStatusFormat, PayCompositionFormat } from '@/utils/tyepconvert'
import constant from '@/utils/constant'
import OrderDescDialog from './OrderDescDialog.vue'
import { Message, MessageBox } from 'element-ui'
import ExpressDialog from './componetns/ExpressDialog.vue'
import ShippedDialog from './componetns/ShippedDialog.vue'
import UpdateShippedDialog from './componetns/UpdateShippedDialog.vue'
import {getUser} from '@/store/userStore'
import UserWealthRecordDialog from '@/views/user/components/UserWealthRecordDialog.vue'
import MixedPayAbnormalDialog from './components/MixedPayAbnormalDialog.vue'
import RefundPostProcessCorrectionDialog from './components/RefundPostProcessCorrectionDialog.vue'
import RefundPostProcessCorrectionBatchDialog from './components/RefundPostProcessCorrectionBatchDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    OrderDescDialog,
    ExpressDialog,
    ShippedDialog,
    UserWealthRecordDialog,
    UpdateShippedDialog,
    MixedPayAbnormalDialog,
    RefundPostProcessCorrectionDialog,
    RefundPostProcessCorrectionBatchDialog,
  },
})
export default class OrderList extends Vue {
  private queryParam: any = {
    // orderType: 0,
    startRow: 1,
    limit: 10,
    createTimeDaterange: [],
    successRefundTimeDaterange:[]
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private selectData: Array<any> = []

  private user = getUser()

  private activeMenu: any = 'waitConfirm'
  private orderCounts = {}
  private shopIdOption: Array<any> = []
  private shopIdQueryParam: QueryModel = { title: '店铺', param: 'shopId' , type: 'select', selectData:  this.shopIdOption,show:()=>{return this.user.user.role != 2}}

  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '订单类型', param: 'orderType', type: 'select', selectData: constant.OrderType },
    this.shopIdQueryParam,
    { title: '订单状态', param: 'orderStatus', type: 'select', selectData: constant.OrderStatus },
    { title: '用户ID', param: 'userId' },
    { title: '客户手机号', param: 'mobilePhone' },
    { title: '订单编号', param: 'orderCode' },
    { title: '退款单号', param: 'orderRefundCode', show: () => this.activeMenu === 'refund' },
    { title: '商品名称', param: 'goodsName' },
    { title: '供应链名称', param: 'supplyChainNameLike' },
    { title: '工厂名称', param: 'factoryNameLike' },
    { title: '支付方式', param: 'payChannel',type: 'select', selectData: constant.PayChannel  },
    { title: '混合支付订单', param: 'mixedPayOrderEq', type: 'select', selectData: [ { label: '不限', value: null }, { label: '是', value: true }, { label: '否', value: false } ] },
    { title: '混合抵扣异常', param: 'mixedPayReleaseAbnormalEq', type: 'select', selectData: [ { label: '不限', value: null }, { label: '仅异常', value: true } ], show: () => this.activeMenu !== 'refund' },
    { title: '退款后置异常', param: 'refundPostProcessAbnormalEq', type: 'select', selectData: [ { label: '不限', value: null }, { label: '仅异常', value: true } ], show: () => this.user.user.role !== 2 },
    { title: '使用优惠券', param: 'couponUsedEq', type: 'select', selectData: [ { label: '不限', value: null }, { label: '是', value: true }, { label: '否', value: false } ] },
    { title: '配送方式', param: 'deliveryType',type: 'select', selectData: [ { label: '快递', value: 0 },{ label: '自提', value: 1 },]  },
    { title: '是否为分销订单', param: 'distributionOrderEq', type: 'select', selectData: [ { label: '不限', value: null }, { label: '是', value: 1 }, { label: '否', value: 0 } ] },
    { title: '是否为复购订单', param: 'repurchaseOrderEq', type: 'select', selectData: [ { label: '不限', value: null }, { label: '是', value: 1 }, { label: '否', value: 0 } ] },
    { title: '是否为特价订单', param: 'specialPriceOrderEq', type: 'select', selectData: [ { label: '不限', value: null }, { label: '是', value: 1 }, { label: '否', value: 0 } ] },
    { title: '是否为薪购专区订单', param: 'xinGouZoneOrderEq', type: 'select', selectData: [ { label: '不限', value: null }, { label: '是', value: 1 }, { label: '否', value: 0 } ] },
    { title: '特殊关单批次', param: 'specialRefundBatchNo' },
    { title: '特殊关单标记', param: 'specialRefundFlagEq', type: 'select', selectData: [ { label: '不限', value: null }, { label: '无', value: 0 }, { label: '已特殊关单', value: 1 }, { label: '已回滚', value: 2 } ] },
    { title: '排队免单标记', param: 'paiduiMiandanFlag',type: 'select', selectData: [ { label: '不是排队免单', value: 0 },{ label: '是排队免单', value: 1 },{ label: '已免单未收货', value: 2 },{ label: '已免单已收货', value: 3 },{ label: '已退款免单已退回', value: 4 }]  },
    { title: '是否特价订单', param: 'specialPriceOrderFlag', type: 'select', selectData: [ { label: '不限', value: null }, { label: '是', value: 1 }, { label: '否', value: 0 } ] },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange', show: () => this.activeMenu !== 'refund' },
    { title: '订单创建时间', param: 'createTimeDaterange', type: 'daterange', show: () => this.activeMenu === 'refund' },
    { title: '支付成功时间', param: 'successPayTimeDaterange', type: 'daterange' },
    { title: '确认收货时间', param: 'receiveTimeDaterange', type: 'daterange' },
    { title: '退款成功时间', param: 'successRefundTimeDaterange', type: 'daterange' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '批量确认', type: 'primary', click: this.batchConfirmOrder, disable: this.batchDisable },
    { title: '批量退款补正', type: 'warning', click: this.openBatchRefundPostProcessCorrection, disable: this.batchRefundCorrectionDisable, show: () => this.isPlatformAdmin() },
    // { title: '批量发货', type: 'primary', click: this.batchDeliveryOrder, disable: this.batchDisable },
    { title: '批量导出', type: 'primary', click: this.exportOrderHandle},
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '选择',  type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    { title: '店铺', param: 'shopId',width:100 ,formatter: this.shopNameForam, overflow: true,hide:this.user.user.role == 2},
    { title: '订单编号', param: 'orderCode', overflow: true,width:200 },
    { title: '订单类型', param: 'orderType', formatter: OrderTypeFormat },
    { title: '分销订单', param: 'distributionOrderFlag', width: 92, formatter: this.formatDistributionOrderFlag },
    { title: '复购订单', param: 'repurchaseOrderFlag', width: 92, formatter: this.formatRepurchaseOrderFlag },
    { title: '特价订单', param: 'specialPriceOrderFlag', width: 92, formatter: this.formatSpecialPriceOrderFlag },
    { title: '薪购专区订单', param: 'xinGouZoneOrderFlag', width: 108, formatter: this.formatXinGouZoneOrderFlag },
    { title: '特殊关单批次', param: 'specialRefundBatchNo', width: 160, overflow: true },
    { title: '特殊关单', param: 'specialRefundFlag', width: 100, formatter: this.formatSpecialRefundFlag },
    { title: '用户ID', param: 'userId',width:100 },
    { title: '客户手机号', param: 'mobilePhone',width:120 },
    { title: '订单金额', param: 'orderAmount', formatter: PriceFormat },
    // { title: '优惠金额', param: 'discountAmount', formatter: PriceFormat },
    { title: '支付金额', param: 'payAmount', formatter: PriceFormat },
    { title: '累计退款', param: 'refundAmount', formatter: PriceFormat, width: 100 },
    { title: '退款情况', param: 'haveRefund', cellType: 'refundScope', width: 118 },
    { title: '支付优惠金额', param: 'paymentDiscountAmount', formatter: PriceFormat },
    { title: '支付方式', param: 'payChannel', formatter: PayCompositionFormat },
    { title: '混合支付', param: 'payMixed', width: 88, formatter: this.formatMixedPayFlag },
    { title: '使用优惠券', param: 'couponAmount', width: 92, formatter: this.formatCouponUsedFlag },
    { title: '优惠券', param: 'orderCouponUsed', width: 120, formatter: this.formatCouponTemplateName, overflow: true },
    { title: '券抵扣(元)', param: 'couponAmount', width: 100, formatter: this.formatCouponAmountYuan },
    { title: '混合-绿豆(元)', param: 'payMixedMungDeductFen', width: 110, formatter: PriceFormat },
    { title: '混合-积分(元)', param: 'payMixedPointsDeductFen', width: 110, formatter: PriceFormat },
    { title: '混合-现金(元)', param: 'payMixedCashFen', width: 110, formatter: PriceFormat },
    { title: '订单PV', param: 'orgPv', formatter: PriceFormat },
    { title: '手续费', param: 'serviceFee', formatter: PriceFormat },
    { title: '预计结算金额', param: 'settlementAmount', formatter: PriceFormat },
    // { title: '返还积分', param: 'returnIntegral', formatter: PriceFormat },
    { title: '配送方式', param: 'deliveryType', formatter: (value)=>value == 0 ? '快递':'自提'},
    // { title: '配送地址', param: 'deliveryAddress', overflow: true },
    { title: '状态', param: 'orderStatus', formatter: OrderStatusFormat },
    { title: '混合异常', param: 'mixedPayReleaseAbnormal', width: 88, formatter: this.formatMixedPayAbnormal },
    { title: '退款异常', param: 'refundPostProcessAbnormal', width: 88, formatter: this.formatRefundPostProcessAbnormal, hide: this.user.user.role === 2 },
    { title: '吉客云状态', param: 'jkorderstatus', width: 100 },
    { title: '发货时间', param: 'platformDeliveryTime', formatter: DateFormat, overflow: true,width:160 },
    { title: '确认收货时间', param: 'receiveTime', formatter: DateFormat, overflow: true,width:160 },
    { title: '退款成功时间', param: 'successRefundTime', formatter: DateFormat, overflow: true,width:160 },
    { title: '创建时间', param: 'createTime', formatter: DateFormat, overflow: true,width:160 },
    {
      title: '操作',
      width: 240,
      fixed: 'right',
      operation: [
        { title: '查看详情', icon: 'el-icon-document', click: (data) => this.openDialog('OrderDescDialog', {...data,shopName:this.shopNameForam(data.shopId)}) },
        { title: '确认订单', click: this.confirmOrder, show: this.showConfirmOrder },
        { title: '拒绝订单', click: this.refusedOrder, show: this.showConfirmOrder },
        { title: '同意退款', click: this.refundOrderHandle, show: this.showConfirmRefund },
        { title: '确认退货打款', click: this.confirmReturnRefundHandle, show: this.showConfirmReturnRefund },
        { title: '取消退款', click: this.cancelRefundOrderHandle, show: this.showCancelRefund },
        { title: '发货', click: this.deliveryOrder, show: this.showDeliveryOrder },
        { title: '查看物流', click: this.openExpress, show: this.showOpenExpress },
        // { title: '修改物流单号', click: this.updateDeliveryOrder, show: this.showUpdateDeliveryOrder },
        { title: '积分发放情况', click: this.openWealthRecord, show: ()=>{return this.user.user.role != 2} },
        { title: '处理混合异常', type: 'warning', click: this.openMixedPayAbnormal, show: this.showMixedPayAbnormalHandle },
        { title: '退款补正', type: 'warning', click: this.openRefundPostProcessCorrection, show: this.showRefundPostProcessCorrection },
      ],
    },
  ]

  /** 售后/退款 Tab：一行一条 zy_order_refund */
  private refundTableHander: Array<TableHander> = [
    { title: '选择', type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    // 按需求调整列顺序：订单号第二列、退款单号第四列
    { title: '订单编号', param: 'orderCode', width: 180, overflow: true },
    { title: '店铺', param: 'shopId', width: 100, formatter: this.shopNameForam, overflow: true, hide: this.user.user.role == 2 },
    { title: '退款单号', param: 'orderRefundCode', width: 200, overflow: true },
    { title: '订单创建时间', param: 'orderCreateTime', width: 160, formatter: DateFormat, overflow: true },
    { title: '退款方式', param: 'refundType', width: 96, formatter: this.refundTypeFormat },
    { title: '退款状态', param: 'refundStatus', width: 120, formatter: RefundStatusFormat },
    { title: '退款异常', param: 'refundPostProcessAbnormal', width: 88, formatter: this.formatRefundPostProcessAbnormal, hide: this.user.user.role === 2 },
    { title: '退款金额', param: 'refundAmount', width: 100, formatter: PriceFormat },
    { title: '退款商品/数量', param: 'goodsLines', width: 340, formatter: this.formatRefundGoodsLines, overflow: true },
    { title: '订单状态', param: 'orderStatus', formatter: OrderStatusFormat, width: 100 },
    { title: '用户ID', param: 'userId', width: 88 },
    { title: '客户手机号', param: 'mobilePhone', width: 120 },
    { title: '申请时间', param: 'createTime', formatter: DateFormat, width: 160, overflow: true },
    {
      title: '操作',
      width: 260,
      fixed: 'right',
      operation: [
        { title: '查看详情', icon: 'el-icon-document', click: (data) => this.openDialog('OrderDescDialog', { ...data, shopName: this.shopNameForam(data.shopId) }) },
        { title: '确认订单', click: this.confirmOrder, show: this.showConfirmOrder },
        { title: '拒绝订单', click: this.refusedOrder, show: this.showConfirmOrder },
        { title: '同意退款', click: this.refundOrderHandle, show: this.showConfirmRefund },
        { title: '确认退货打款', click: this.confirmReturnRefundHandle, show: this.showConfirmReturnRefund },
        { title: '取消退款', click: this.cancelRefundOrderHandle, show: this.showCancelRefund },
        { title: '发货', click: this.deliveryOrder, show: this.showDeliveryOrder },
        { title: '查看物流', click: this.openExpress, show: this.showOpenExpress },
        { title: '积分发放情况', click: this.openWealthRecord, show: () => { return this.user.user.role != 2 } },
        { title: '退款补正', type: 'warning', click: this.openRefundPostProcessCorrection, show: this.showRefundPostProcessCorrection },
      ],
    },
  ]

  get activeTableHander() {
    return this.activeMenu === 'refund' ? this.refundTableHander : this.tableHander
  }

  private refundTypeFormat(cellValue: any) {
    return Number(cellValue) === 2 ? '退货退款' : '仅退款'
  }

  private formatMixedPayFlag(v: any) {
    if (v === true || v === 1) {
      return '是'
    }
    if (v === false || v === 0) {
      return '否'
    }
    return '-'
  }

  private formatMixedPayAbnormal(v: any) {
    return v === true ? '异常' : '-'
  }

  private showMixedPayAbnormalHandle(data: any) {
    return data && data.mixedPayReleaseAbnormal === true
  }

  private openMixedPayAbnormal(data: any) {
    const dlg = this.$refs.MixedPayAbnormalDialog as MixedPayAbnormalDialog
    dlg.open(data.orderCode, data.orderStatus)
  }

  private formatRefundPostProcessAbnormal(v: any) {
    return v === true ? '异常' : '-'
  }

  private isPlatformAdmin() {
    return this.user && this.user.user && this.user.user.role !== 2
  }

  private showRefundPostProcessCorrection(data: any) {
    return this.isPlatformAdmin() && data && data.refundPostProcessAbnormal === true
  }

  private openRefundPostProcessCorrection(data: any) {
    const dlg = this.$refs.RefundPostProcessCorrectionDialog as RefundPostProcessCorrectionDialog
    dlg.open(data.orderCode)
  }

  private batchRefundCorrectionDisable() {
    return this.selectData.length <= 0
  }

  private openBatchRefundPostProcessCorrection() {
    if (this.selectData.length <= 0) {
      Message.warning('请先勾选要补正的订单')
      return
    }
    const codes = Array.from(new Set(this.selectData.map((e: any) => e.orderCode).filter(Boolean)))
    const dlg = this.$refs.RefundPostProcessCorrectionBatchDialog as RefundPostProcessCorrectionBatchDialog
    dlg.open(codes)
  }

  private formatCouponUsedFlag(_v: any, row: any) {
    const amt = row && row.couponAmount != null ? Number(row.couponAmount) : 0
    return amt > 0 ? '是' : '否'
  }

  private formatCouponTemplateName(_v: any, row: any) {
    const amt = row && row.couponAmount != null ? Number(row.couponAmount) : 0
    if (amt <= 0) {
      return '-'
    }
    const u = row && row.orderCouponUsed
    if (!u) {
      return '-'
    }
    if (u.templateName) {
      return u.templateName
    }
    return u.couponRuleDesc || '-'
  }

  private formatCouponAmountYuan(v: any) {
    const amt = v != null ? Number(v) : 0
    if (amt <= 0) {
      return '-'
    }
    return PriceFormat(amt)
  }

  private formatRefundGoodsLines(_cellValue: any, row: any) {
    const lines = row.goodsLines
    if (!lines || !lines.length) {
      return '-'
    }
    return lines.map((g: any) => {
      const spec = g.skuSpecDesc ? '(' + g.skuSpecDesc + ')' : ''
      return (g.goodsName || '-') + spec + '×' + (g.count != null ? g.count : 0)
    }).join('、')
  }

  // 打开物流详情弹窗
  private openExpress(data:any){
    // data. 为行数据
    const t = this.$refs.ExpressDialog as ExpressDialog
    // TODO 传入物流编号
    t.open(data.orderCode)
  }
  // 是否显示 查看物流 按钮
  private showOpenExpress(data:any){
    // data. 为行数据
    // orderStatus 订单状态，可查看后端  枚举 OrderStatus 或前端常量 OrderStatus
    if(data.orderStatus == 4 && data.deliveryType == 0){
      return true;
    }
    return false
  }

  // 打开积分流水
  public openWealthRecord(data:any){
    const d = this.$refs.UserWealthRecordDialog as UserWealthRecordDialog
    d.open({recordNo: data.orderCode})
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

    this.shopIdQueryParam.selectData = this.shopIdOption

  }

  private formatDistributionOrderFlag(v: any) {
    return Number(v) === 1 ? '是' : '否'
  }

  private formatRepurchaseOrderFlag(v: any) {
    return Number(v) === 1 ? '是' : '否'
  }
  private formatSpecialPriceOrderFlag(v: any) {
    return Number(v) === 1 ? '是' : '否'
  }

  private formatXinGouZoneOrderFlag(v: any) {
    return Number(v) === 1 ? '是' : '否'
  }

  private formatSpecialRefundFlag(v: any) {
    if (Number(v) === 1) return '已关单'
    if (Number(v) === 2) return '已回滚'
    return '-'
  }

  // 显示店铺名称
  private shopNameForam(v:number){
    const t = this.shopIdOption.find(e=>e.value == v)
    if(t){
      return t.label
    }
    return v
  }

  private batchDisable(){
    return this.selectData.length <= 0
  }

  private pageActiveMenu:any = undefined
  public activated(){
    if (this.$route.query.createTime) {
      this.queryParam.createTimeDaterange = [this.$route.query.createTime + ' 00:00:00',this.$route.query.createTime + ' 23:59:59'];
    }else {
      this.queryParam.createTimeDaterange = []
    }
    if (this.$route.query.successRefundTime) {
      this.queryParam.successRefundTimeDaterange = [this.$route.query.successRefundTime + ' 00:00:00',this.$route.query.successRefundTime + ' 23:59:59'];
    }else {
      this.queryParam.successRefundTimeDaterange = []
    }
    const am = this.$route.query.activeMenu
    if(this.pageActiveMenu != am){
      // 如果路由的菜单不一致则刷新
      this.pageActiveMenu = am
      this.activeMenuSelect(am)
      // this.loadData()
    } else {
      this.loadData()
    }

  }
  public async created() {
    const am = this.$route.query.activeMenu
    if(am){
      this.activeMenu = am
    }
    this.loadData()
    this.loadShop()
  }

  private exportOrderHandle(){
    // 导出
    // if(this.selectData.length <= 0){
    //   return
    // }

    const loading = this.$loading({
          lock: true,
          text: '正在导出订单',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

      const param = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      const orderIds = this.selectData.map(e=>e.id)
      param.orderIds = orderIds

      ExportOrder(param,"导出订单明细.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  private async batchConfirmOrder(){
    if(this.selectData.length <= 0){
      return
    }
    // 只有筛选已支付的订单
    const hs = this.selectData.filter(e=>e.orderStatus == 2)
    if(hs.length <= 0){
      Message.error('有效数据为0.只有状态为已支付的才能执行确认操作')
      return
    }

    MessageBox.confirm('批量确认执行数据条数为：'+hs.length+"，是否确认", '提示', {
      type: 'warning',
    }).then(async () => {
      const orderCodes = hs.map(e=>e.orderCode)
      const ruslt = await BatchConfirmOrder({ orderCodes })
      if (ruslt) {
        Message.success('批量确认成功')
        this.loadData()
      }
    })

  }

  private async batchDeliveryOrder(){
    if(this.selectData.length <= 0){
      return
    }
    // 只有筛选已确认的订单
    const hs = this.selectData.filter(e=>e.orderStatus == 3)
    if(hs.length <= 0){
      Message.error('有效数据为0.只有状态为已确认的才能执行发货操作')
      return
    }

    MessageBox.confirm('批量发货执行数据条数为：'+hs.length+"，是否确认", '提示', {
      type: 'warning',
    }).then(async () => {
      const orderCodes = hs.map(e=>e.orderCode)
      const ruslt = await BatchDeliveryOrder({ orderCodes })
      if (ruslt) {
        Message.success('批量发货成功')
        this.loadData()
      }
    })
  }

  //。选择菜单
  private activeMenuSelect(e:any){
    if(this.activeMenu == e){
      return
    }
    this.activeMenu = e
    this.search()
  }

  private getRequestParam(){
    const param = { ...this.queryParam }
    if (!this.queryParam.orderStatus) {
      param.orderStatusNot = -1
    }
    if (param.createTimeDaterange.length > 0) {
      const t = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
      if (this.activeMenu === 'refund') {
        // 售后/退款：按订单创建时间（zy_order_info.create_time）筛选
        param.orderCreateTimes = t
      } else {
        // 订单列表：按订单创建时间（zy_order_info.create_time）筛选
        param.createTimes = t
      }
    }
    if (param.receiveTimeDaterange) {
      param.receiveTimes = DateFormat(param.receiveTimeDaterange[0]) + ',' + DateFormat(param.receiveTimeDaterange[1])
    }
    if (param.successPayTimeDaterange) {
      param.successPayTimes = DateFormat(param.successPayTimeDaterange[0]) + ',' + DateFormat(param.successPayTimeDaterange[1])
    }
    if (param.successRefundTimeDaterange.length > 0) {
      param.successRefundTimes = DateFormat(param.successRefundTimeDaterange[0]) + ',' + DateFormat(param.successRefundTimeDaterange[1])
    }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)

    //  el-menu-item(index="waitConfirm") 待确认
    //   el-menu-item(index="waitShipment") 待发货
    //   el-menu-item(index="finishShipment") 已发货
    //   el-menu-item(index="finish") 已完成
    //   el-menu-item(index="refund") 退货退款
    // 根据选择菜单的不同查询不同的数据
    if(this.activeMenu == 'waitConfirm'){
      // 待确认
      param.orderStatus = 2
    }else if(this.activeMenu == 'waitPay'){
      // 待支付
      param.orderStatusIn = [0,1]
    } else if(this.activeMenu == 'pay'){
      // 待支付
      param.orderStatusIn = [2,3,4,5,6,11,31,32]
    } else if(this.activeMenu == 'waitShipment'){
      // 待发货
      param.orderStatus = 3
    } else if(this.activeMenu == 'finishShipment'){
      // 已发货
      param.orderStatus = 4
    } else if(this.activeMenu == 'finish'){
      // 已完成
      param.orderStatusIn = [5,6]
    } else if(this.activeMenu == 'refund'){
      // 申请退款(21) 置顶，其余按退款单申请时间倒序（与 PageHelper orderBy 一致）
      param.orderBy = ' (CASE WHEN refund_status = 21 THEN 0 ELSE 1 END) ASC, create_time DESC '
    }  else if(this.activeMenu == 'timeoutUnfinish'){
      // 超时未完成订单
      param.orderStatusIn = [2,3,4]

      // 获取当前时间
      const now = new Date();
      // 计算20天前的时间戳（20天的毫秒数：20 * 24 * 60 * 60 * 1000）
      const fifteenDaysAgoTimestamp = now.getTime() - 20 * 24 * 60 * 60 * 1000;
      // 转换为Date对象
      const fifteenDaysAgo = new Date(fifteenDaysAgoTimestamp);
      param.createTimeLt = DateFormat2(fifteenDaysAgo) + ' 00:00:00'
    }
    if (this.activeMenu === 'refund') {
      delete param.mixedPayOrderEq
      delete param.createTimes
    }
    return param
  }

  public async loadData() {
    const param = this.getRequestParam()

    if (this.activeMenu === 'refund') {
      const result = await QueryAfterSaleRefundList(param)
      this.tableTotal = result.total
      this.tableData = result.list
    } else {
      const result = await QueryOrderInfoList(param)
      this.tableTotal = result.total
      this.tableData = result.list
    }

    const resCounts = await QueryOrderInfoCounts(param)
    this.orderCounts = resCounts

  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  private selectChange(selection: any) {
    this.selectData = selection
  }

  private openDialog(dia: string, data?: any) {
    const f = this.$refs[dia] as any
    f.open(data)
  }

  private showConfirmOrder(data: any) {
    return data.orderStatus == 2
  }
  /** 与小程序一致：部分退款时订单状态可仍为 2～6，仅「退款中(31)」才能操作会漏单 */
  private canOperateRefundOrder(data: any) {
    const s = data.orderStatus
    return s === 31 || s === 2 || s === 3 || s === 4 || s === 5 || s === 6
  }
  private showConfirmRefund(data: any) {
    return data.refundStatus === 21 && this.canOperateRefundOrder(data)
  }
  /** 退货退款且买家已填物流：25 物流进行中 / 26 已签收，商家确认后发起原路退款 */
  private showConfirmReturnRefund(data: any) {
    const rt = Number(data.refundType)
    const st = data.refundStatus
    return rt === 2 && (st === 25 || st === 26) && this.canOperateRefundOrder(data)
  }
  private showCancelRefund(data: any) {
    return (data.refundStatus === 21 || data.refundStatus === 24) && this.canOperateRefundOrder(data)
  }
  private showDeliveryOrder(data: any) {
    return data.orderStatus == 3
  }
  private showUpdateDeliveryOrder(data: any) {
    return data.deliveryType == 0 &&  data.orderStatus == 4
  }

  private refundOrderHandle(data: any){
    MessageBox.confirm('是否同意退款？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await ConfirmRefund({ orderCode: data.orderCode })
      if (ruslt) {
        Message.success('订单已同意退款')
        this.loadData()
      }
    })
  }
  private confirmReturnRefundHandle(data: any) {
    MessageBox.confirm(
      '确认对当前退货退款单发起原路退款？（适用于买家已填写退货物流，商家已收货或同意打款的情形）',
      '确认退货打款',
      { type: 'warning' }
    ).then(async () => {
      const ruslt = await ConfirmReturnRefundAfterLogistics({ orderCode: data.orderCode })
      if (ruslt) {
        Message.success('已提交退款，请稍后查看退款状态')
        this.loadData()
      }
    })
  }
  private cancelRefundOrderHandle(data: any){
    MessageBox.confirm('是否取消退款？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await CancelRefund({ orderCode: data.orderCode })
      if (ruslt) {
        Message.success('订单已取消退款')
        this.loadData()
      }
    })
  }

  private confirmOrder(data: any) {
    MessageBox.confirm('确定要将该订单变为已确认吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await ConfirmOrder({ orderCode: data.orderCode })
      if (ruslt) {
        Message.success('订单确认成功')
        this.loadData()
      }
    })
  }
  private refusedOrder(data: any) {
    MessageBox.prompt('请输入拒绝理由', '提示', {
      type: 'warning',
    }).then(async (refusedMsg: any) => {
      const ruslt = await RefusedOrder({ orderCode: data.orderCode, refusedMsg: refusedMsg.value })
      if (ruslt) {
        Message.success('订单已拒绝')
        this.loadData()
      }
    })
  }
  private deliveryOrder(data: any) {

    if(data.deliveryType == 0){
      // 快递
      const d = this.$refs.ShippedDialog as ShippedDialog
      d.open(data)
    } else {
      // 自提
      MessageBox.prompt('请输入提货码', '提示', {
        type: 'warning',
      }).then(async (md: any) => {
        const ruslt = await DeliveryOrder({ orderCode: data.orderCode,writeOffCode: md.value })
        if (ruslt) {
          Message.success('订单发货成功')
          this.loadData()
        }
      })
    }

  }
  private updateDeliveryOrder(data: any) {

    if(data.deliveryType == 0){
      // 快递
      const d = this.$refs.UpdateShippedDialog as UpdateShippedDialog
      d.open(data)
    } else {
      this.$message.error("非快递订单，无法更换物流单号")
    }

  }
}
